"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.seatsService = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _axios = _interopRequireDefault(require("axios"));

var SeatsService = /*#__PURE__*/function () {
  function SeatsService() {
    (0, _classCallCheck2.default)(this, SeatsService);
    (0, _defineProperty2.default)(this, "pendingRequest", null);
  }

  (0, _createClass2.default)(SeatsService, [{
    key: "getData",
    value: function () {
      var _getData = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var _this = this;

        var currentPromise;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.pendingRequest) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", this.pendingRequest);

              case 2:
                currentPromise = _axios.default.get('/team/getSeatsSettings').finally(function () {
                  // Clear the pending request after completion
                  if (_this.pendingRequest === currentPromise) {
                    _this.pendingRequest = null;
                  }
                });
                this.pendingRequest = currentPromise;
                return _context.abrupt("return", currentPromise);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getData() {
        return _getData.apply(this, arguments);
      }

      return getData;
    }()
  }]);
  return SeatsService;
}();

var seatsService = new SeatsService();
exports.seatsService = seatsService;